import { CONNECTED_REQUESTS_MASS_EDIT_DEADLINE_FIELD_TEXT_KEYS } from './DeadlineValueField.constants'

export function getDeadlineFieldTexts(t) {
  return {
    dateLabel: t(
      CONNECTED_REQUESTS_MASS_EDIT_DEADLINE_FIELD_TEXT_KEYS.dateLabel
    ),
    datePlaceholder: t(
      CONNECTED_REQUESTS_MASS_EDIT_DEADLINE_FIELD_TEXT_KEYS.datePlaceholder
    ),
    timeLabel: t(
      CONNECTED_REQUESTS_MASS_EDIT_DEADLINE_FIELD_TEXT_KEYS.timeLabel
    ),
    timePlaceholder: t(
      CONNECTED_REQUESTS_MASS_EDIT_DEADLINE_FIELD_TEXT_KEYS.timePlaceholder
    ),
  }
}
